import WithSuspense from './WithSuspense'

export default WithSuspense
